import State from '../interfaces/states/State';

import { createSelector } from 'reselect';

const getActivityMonth = createSelector(
  (state: State) => state.activity.activityData,
  (activityData): Date[] => {
    if (activityData.dates) {
      return activityData.dates.map((month) => {
        return new Date(month);

      });
    } else {
      return null;
    }
  }
);

export default getActivityMonth;
